const GrowthChart = require('okCharts/GrowthChart');

module.exports = GrowthChart;
